/**
 * @flow
 */
'use strict';

export const clGoodToBadCodes = [
  {"code":"Good"},
  {"code":"Poor"},
  {"code":"Stable"},
]

export const clRotationCodes = [
  {"code":"Right: 20"},
  {"code":"Right: 15",},
  {"code":"Right: 10"},
  {"code":"Left: 5"},
  {"code":"Left: 10"},
  {"code":"Left: 15"},
  {"code":"Left: 20"}
]

export const clMovementCodes = [
  {"code":"Good"},
  {"code":"Tight"},
  {"code":"Loose"},
  {"code":"Too loose"}
]

export const clCentrationCodes = [
  {"code":"Centered"},
  {"code":"C--"},
  {"code":"C-"},
  {"code":"C+"},
  {"code":"C++"}
]

export const clNormalTo5Codes = [
  {"code":"Normal"},
  {"code":"1"},
  {"code":"2"},
  {"code":"3"},
  {"code":"4"},
  {"code":"5"}
]

export const clSolutionCodes = [
  {"code":"Bio True"},
  {"code":"Boston Compound"},
  {"code":"Boston Simplicity"},
  {"code":"Clear care"},
  {"code":"Opti-Free"},
  {"code":"Renu"},
  {"code":"Complete"},
  {"code":"PeroxiClear"},
  {"code":"SoloCare"}
]

export const clReplacementCodes = [
    {"code":"Soft"},
    {"code":"RPG"},
    {"code":"Quarterly"},
    {"code":"Monthly"},
    {"code":"Biweekly"},
    {"code":"Weekly"},
    {"code":"Daily"},
    {"code":"Yearly"}
]

export const clComfortCodes = [
    {"code":"Good"},
    {"code":"Poor"},
    {"code":"Bad"},
    {"code":"Eyes feel dry"},
    {"code":"Bad vision"},
    {"code":"Good vision"}
]

export const clWearingHabitCodes = [
    {"code":"Normal"},
    {"code":"Occasional"},
    {"code":"Everyday"},
    {"code":"Overnight"},
    {"code":"Swimming"},
    {"code":"Bathing"},
    {"code":"Overusage"},
    {"code":"No spectacles"}
]

export const clCleaningHabitCodes = [
    {"code":"Normal"},
    {"code":"Cleaning with tap water"},
    {"code":"Reusing cleaning solution"},
    {"code":"Not washing hands"},
    {"code":"Rehydrate with saliva"},
    {"code":"Peroxyde Solution"},
    {"code":"Saline Solution"},
    {"code":"Multipurpose solution"},
    {"code":"No rub"}
]

export const contactLenses = []

export const clFittingTypeCodes = []
